/// <amd-module name="Release/Landing/LeftPanel/ActivePipelines/ActivePipelineFavoritesStar" />
import * as React from "react";

import { VssComponent, IVssComponentProperties, IVssComponentContext, ReactRootComponent } from "VSS/Platform/Layout";
import { IVssPageContext } from "VSS/Platform/Context";

import { FavoritesStar } from "Favorites/Star/FavoritesStar";
import { Favorite, FavoriteCreateParameters } from "Favorites/Common/Contracts/Favorite";
import { IFavoritesService } from "Favorites/Common/FavoritesService";

import { css } from "VSSUI/Util";

import * as Resources from "Release/Landing/Resources";

import { ITfsPageService } from "Tfs/Platform/Page";

import "VSS/LoaderPlugins/Css!Release/Landing/LeftPanel/ActivePipelines/ActivePipelineFavoritesStar";

export interface IActivePipelineFavoritesStarProps extends IVssComponentProperties {
    pageContext: IVssPageContext;
    definitionId: number;
    definitionName: string;
    onAddFavorite?: (favorite: Favorite) => void;
    onRemoveFavorite?: (favorite: Favorite) => void;
}

export const releasePipelineArtifactType: string = "Microsoft.TeamFoundation.ReleaseManagement.DefinitionEntry";
const artifactScopeType: string = "Project";

export class ActivePipelineFavoritesStar extends VssComponent<IActivePipelineFavoritesStarProps, {}>{

    constructor(props: IActivePipelineFavoritesStarProps, context: IVssComponentContext) {
        super(props, context);

        this._favoritesService = this.props.pageContext ? this.props.pageContext.getService("IFavoritesService") : context.pageContext.getService("IFavoritesService");
        this._favoritesService.subscribe(this._onAddFavorite, "favoriteAdded");
        this._favoritesService.subscribe(this._onRemoveFavorite, "favoriteRemoved");
    }

    public render(): React.ReactNode {

        if (this.props.pageContext) {
            return (
                <ReactRootComponent pageContext={this.props.pageContext}>
                    <FavoritesStar
                        artifact={this._getFavorite()}
                        serviceInstanceId={"0000000D-0000-8888-8000-000000000000"}
                        favoritedArialabel={Resources.RemoveFromFavorites}
                        unFavoritedArialabel={Resources.AddToFavorites}
                        className={this.props.className}
                    />
                </ReactRootComponent>
            );
        }
        else {
            return null;
        }
    }

    public componentWillUnmount(): void {
        this._favoritesService.unsubscribe(this._onAddFavorite, "favoriteAdded");
        this._favoritesService.unsubscribe(this._onRemoveFavorite, "favoriteRemoved");
    }

    private _getFavorite(): FavoriteCreateParameters {
        const tfsPageService = this.props.pageContext.getService<ITfsPageService>("ITfsPageService");
        const pageData = tfsPageService.getData();
        const projectId = pageData && pageData.project ? pageData.project.id : "";
        const projectName = pageData && pageData.project ? pageData.project.name : "";
        const favorite = {
            artifactId: this.props.definitionId ? this.props.definitionId.toString() : "",
            artifactName: this.props.definitionName,
            artifactType: releasePipelineArtifactType,
            artifactScope: {
                id: projectId,
                name: projectName,
                type: artifactScopeType
            }
        } as FavoriteCreateParameters;

        return favorite;
    }

    private _onAddFavorite = (favorite: Favorite) => {
        if (this.props.definitionId === parseInt(favorite.artifactId) && this.props.onAddFavorite) {
            this.props.onAddFavorite(favorite);
        }
    }

    private _onRemoveFavorite = (favorite: Favorite) => {
        if (this.props.definitionId === parseInt(favorite.artifactId) && this.props.onRemoveFavorite) {
            this.props.onRemoveFavorite(favorite);
        }
    }

    private readonly _favoritesService: IFavoritesService;
}
